import { createContext } from 'react';

export const detectionBoundary = createContext(true);
